import React from 'react';
import { motion } from 'framer-motion';
import { Monitor, Smartphone, ShoppingCart, Palette, Database, Cloud } from 'lucide-react';
const services = [{
  icon: Monitor,
  title: 'Web Development',
  description: 'Custom, responsive websites built with modern technologies like React, Next.js, and Tailwind CSS.'
}, {
  icon: Smartphone,
  title: 'Mobile App Development',
  description: 'Native and cross-platform mobile applications for iOS and Android that deliver seamless user experiences.'
}, {
  icon: ShoppingCart,
  title: 'E-commerce Solutions',
  description: 'Robust online stores with secure payment gateways, inventory management, and conversion-focused design.'
}, {
  icon: Palette,
  title: 'UI/UX Design',
  description: 'User-centered design that combines aesthetics with functionality to create intuitive digital products.'
}, {
  icon: Database,
  title: 'Backend Development',
  description: 'Scalable server-side solutions, API development, and database management for complex applications.'
}, {
  icon: Cloud,
  title: 'Cloud Services',
  description: 'Deployment, hosting, and maintenance services to ensure your applications are always available and secure.'
}];
export function Services() {
  return <section id="services" className="py-20 bg-slate-950" data-id="element-280">
      <div className="container mx-auto px-4" data-id="element-281">
        <div className="text-center mb-16" data-id="element-282">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-283">
            Our Expertise
          </h2>
          <div className="w-20 h-1 bg-red-600 mx-auto mb-6" data-id="element-284"></div>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-285">
            We offer a comprehensive suite of digital services to help your
            business grow and succeed in the modern digital landscape.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-286">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-slate-900 p-8 rounded-xl border border-slate-800 hover:border-red-500/50 transition-all group hover:shadow-2xl hover:shadow-red-900/10" data-id="element-287">
              <div className="w-14 h-14 bg-slate-800 rounded-lg flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors" data-id="element-288">
                <service.icon className="w-7 h-7 text-red-500 group-hover:text-white transition-colors" data-id="element-289" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-290">
                {service.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-291">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}